import React, { Component } from 'react';
import PropTypes from 'prop-types';

class  XCheckbox extends Component{

    constructor(props) {
        super(props);
        let checked=false;
        if(props.checked==="checked") checked=true;
        this.state = {checked:checked};
        this.props=props;
    }

    setChecked() {
        this.setState({checked: true});
    }

    setUnChecked() {
        this.setState({checked: false});
    }


    render(){
        const {
            className,
            id,
            eleRef,
            onChange,
            onClick,
            onDoubleClick,
            readonly,
            value,
        } = this.props;

        let isReadonly;
        if(readonly) isReadonly='readonly';

        return(
            <input ref={eleRef} className={className} id={id}   onChange={onChange} value={value} defaultChecked={this.state.checked}
              readOnly={isReadonly}   onClick={onClick} onDoubleClick={onDoubleClick}  type="checkbox"  />
        )
    }

}


XCheckbox.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    eleRef: PropTypes.any,
    checked: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    readonly: PropTypes.bool,
    value: PropTypes.any,
};

XCheckbox.defaultProps = {
    checked:"",
};

export default  XCheckbox;

